(function() {
  var ORDER_LOOKUP_URL = "https://scoochify.com/api/public/order-tracking";
  window.ScoochTrackOrderLoaded = true;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function scoochValue(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : "";
  }

  function normalizeOrderNumber(value) {
    return value.replace(/^#+/, "").replace(/\D/g, "");
  }

  function looksLikeOrderNumber(value) {
    var clean = value.trim();
    var digits = normalizeOrderNumber(clean);
    return clean.charAt(0) === "#" || (/^\d+$/.test(clean) && digits.length >= 4 && digits.length <= 8);
  }

  function showTrackMessage(message, color) {
    var el = document.getElementById("ScoochTrackMessage");
    if (!el) return;
    el.textContent = message || "";
    el.style.display = message ? "block" : "none";
    el.style.color = color || "#6c7680";
  }

  function setResultVisible(visible) {
    var result = document.getElementById("scoochTrackResult");
    if (result) result.style.display = visible ? "block" : "none";
  }

  function setLookupMode(mode) {
    var trackingTab = document.getElementById("ScoochTrackingTab");
    var orderTab = document.getElementById("ScoochOrderTab");
    var trackingPanel = document.getElementById("ScoochTrackingPanel");
    var orderPanel = document.getElementById("ScoochOrderPanel");
    var isOrder = mode === "order";

    if (trackingTab) {
      trackingTab.setAttribute("aria-selected", isOrder ? "false" : "true");
      trackingTab.classList.toggle("is-active", !isOrder);
    }
    if (orderTab) {
      orderTab.setAttribute("aria-selected", isOrder ? "true" : "false");
      orderTab.classList.toggle("is-active", isOrder);
    }
    if (trackingPanel) trackingPanel.style.display = isOrder ? "none" : "block";
    if (orderPanel) orderPanel.style.display = isOrder ? "block" : "none";
    showTrackMessage("");
    setResultVisible(false);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatDateTime(value) {
    if (!value) return "";
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    });
  }

  function formatLocation(event) {
    var parts = [event.city, event.state, event.country].filter(Boolean);
    return parts.join(", ");
  }

  function statusClass(status) {
    var clean = String(status || "").toLowerCase();
    if (clean.indexOf("delivered") !== -1) return "is-delivered";
    if (clean.indexOf("transit") !== -1 || clean.indexOf("accepted") !== -1) return "is-transit";
    return "is-pending";
  }

  function renderTrackingResult(data) {
    var container = document.getElementById("ScoochShipmentContainer");
    var tracking = data && data.tracking ? data.tracking : {};
    var events = Array.isArray(tracking.events) ? tracking.events : [];
    var status = tracking.status || data.status || "Tracking available";
    var trackingNumber = tracking.trackingNumber || data.trackingNumber || "";
    var trackingUrl = tracking.trackingUrl || data.trackingUrl || "";
    var latestEvent = events[0] || null;
    var html = "";

    setResultVisible(true);
    showTrackMessage("");

    if (!container) return;

    html += '<div class="scooch-shipment-card">';
    html += '<div class="scooch-shipment-summary">';
    html += '<div>';
    html += '<p class="scooch-shipment-kicker">Current status</p>';
    html += '<strong class="scooch-shipment-status ' + statusClass(status) + '">' + escapeHtml(status) + '</strong>';
    if (tracking.carrierStatus && tracking.carrierStatus !== status) {
      html += '<p class="scooch-shipment-note">' + escapeHtml(tracking.carrierStatus) + '</p>';
    } else if (latestEvent && latestEvent.description) {
      html += '<p class="scooch-shipment-note">' + escapeHtml(latestEvent.description) + '</p>';
    }
    html += '</div>';
    if (trackingUrl) {
      html += '<a class="scooch-shipment-link" href="' + escapeHtml(trackingUrl) + '" target="_blank" rel="noopener">Open carrier tracking</a>';
    }
    html += '</div>';

    html += '<dl class="scooch-shipment-meta">';
    if (trackingNumber) {
      html += '<div><dt>Tracking number</dt><dd>' + escapeHtml(trackingNumber) + '</dd></div>';
    }
    if (data.carrier) {
      html += '<div><dt>Carrier</dt><dd>' + escapeHtml(data.carrier) + '</dd></div>';
    }
    if (tracking.actualDeliveryAt) {
      html += '<div><dt>Delivered</dt><dd>' + escapeHtml(formatDateTime(tracking.actualDeliveryAt)) + '</dd></div>';
    } else if (tracking.estimatedDeliveryAt) {
      html += '<div><dt>Estimated delivery</dt><dd>' + escapeHtml(formatDateTime(tracking.estimatedDeliveryAt)) + '</dd></div>';
    }
    html += '</dl>';

    if (events.length) {
      html += '<ol class="scooch-shipment-events">';
      events.forEach(function(event, index) {
        html += '<li class="' + (index === 0 ? "is-latest" : "") + '">';
        html += '<span class="scooch-shipment-dot"></span>';
        html += '<div>';
        html += '<strong>' + escapeHtml(event.description || event.status || "Shipment update") + '</strong>';
        html += '<p>';
        if (formatDateTime(event.occurredAt)) html += '<span>' + escapeHtml(formatDateTime(event.occurredAt)) + '</span>';
        if (formatLocation(event)) html += '<span>' + escapeHtml(formatLocation(event)) + '</span>';
        html += '</p>';
        html += '</div>';
        html += '</li>';
      });
      html += '</ol>';
    } else {
      html += '<p class="scooch-shipment-empty">Tracking has been created, but carrier scan details are not available yet.</p>';
    }

    html += '</div>';
    container.innerHTML = html;
  }

  // Claude 2026-06-30: single-flight guard so mashing submit / holding Enter doesn't fire
  // multiple concurrent lookups against the public tracking API (last-writer-wins on the result).
  var scoochLookupInFlight = false;

  async function lookupTrackingNumber(trackingNumber) {
    if (scoochLookupInFlight) return;
    scoochLookupInFlight = true;
    try {
      showTrackMessage("Looking up your shipment...");
      setResultVisible(false);

      var response = await fetch(ORDER_LOOKUP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ trackingNumber: trackingNumber })
      });
      var data = await response.json().catch(function() { return {}; });

      if (!response.ok) {
        showTrackMessage(data.error || "Tracking lookup is temporarily unavailable. Please try again later.", "#b42318");
        return;
      }

      if (!data.found) {
        showTrackMessage(data.message || "We could not find that tracking number. Check the number or contact support.", "#b42318");
        return;
      }

      renderTrackingResult(data);
    } catch (err) {
      // Claude 2026-07-06: network/CORS fetch rejection previously left "Looking up..." stuck forever
      showTrackMessage("We could not reach the tracking service. Please check your connection and try again.", "#b42318");
    } finally {
      scoochLookupInFlight = false;
    }
  }

  async function lookupOrder(orderNumber, zip) {
    if (scoochLookupInFlight) return;
    scoochLookupInFlight = true;
    try {
      showTrackMessage("Looking up your order...");
      setResultVisible(false);

      var response = await fetch(ORDER_LOOKUP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderNumber: orderNumber, zip: zip })
      });
      var data = await response.json().catch(function() { return {}; });

      if (!response.ok) {
        showTrackMessage(data.error || "Tracking lookup is temporarily unavailable. Please try again later.", "#b42318");
        return;
      }

      if (!data.found) {
        showTrackMessage(data.message || "We could not find that order. Check your order number and shipping ZIP code, or contact support.", "#b42318");
        return;
      }

      if (data.trackingNumber) {
        renderTrackingResult(data);
        return;
      }

      showTrackMessage(data.message || "We found your order, but tracking is not available yet. You will get an email as soon as it ships.");
    } catch (err) {
      // Claude 2026-07-06: network/CORS fetch rejection previously left "Looking up..." stuck forever
      showTrackMessage("We could not reach the tracking service. Please check your connection and try again.", "#b42318");
    } finally {
      scoochLookupInFlight = false;
    }
  }

  window.ScoochTrackOrderSetLookupMode = setLookupMode;

  function initTrackOrder() {
    if (window.ScoochTrackOrderInitialized) return true;

    var form = document.getElementById("ScoochTrackForm");
    var trackingTab = document.getElementById("ScoochTrackingTab");
    var orderTab = document.getElementById("ScoochOrderTab");
    var lookupInput = document.getElementById("ScoochLookupInput");
    var orderInput = document.getElementById("ScoochOrderInput");
    var zipInput = document.getElementById("ScoochZipInput");

    if (!form) return false;
    window.ScoochTrackOrderInitialized = true;

    form.addEventListener("submit", function(event) {
      event.preventDefault();
      var lookup = scoochValue("ScoochLookupInput");
      var orderNumber = scoochValue("ScoochOrderInput");
      var zip = scoochValue("ScoochZipInput");
      var orderPanel = document.getElementById("ScoochOrderPanel");
      var isOrderMode = orderPanel && orderPanel.style.display !== "none";

      if (isOrderMode) {
        if (!orderNumber || !zip) {
          showTrackMessage("Enter both the order number and shipping ZIP code.", "#b42318");
          var missingField = !orderNumber ? orderInput : zipInput;
          if (missingField) missingField.focus();
          return;
        }
        lookupOrder(normalizeOrderNumber(orderNumber), zip);
        return;
      }

      if (!lookup) {
        showTrackMessage("Enter your tracking number.", "#b42318");
        return;
      }

      if (looksLikeOrderNumber(lookup)) {
        setLookupMode("order");
        if (orderInput) orderInput.value = lookup;
        showTrackMessage("Add the shipping ZIP code so we can look up that order.");
        if (zipInput) zipInput.focus();
        return;
      }

      lookupTrackingNumber(lookup);
    });

    if (trackingTab) {
      trackingTab.addEventListener("click", function() {
        setLookupMode("tracking");
      });
    }

    if (orderTab) {
      orderTab.addEventListener("click", function() {
        setLookupMode("order");
      });
    }

    function submitOnEnter(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event("submit", { cancelable: true }));
        }
      }
    }

    if (lookupInput) lookupInput.addEventListener("keydown", submitOnEnter);
    if (orderInput) orderInput.addEventListener("keydown", submitOnEnter);
    if (zipInput) zipInput.addEventListener("keydown", submitOnEnter);
    return true;
  }

  ready(initTrackOrder);
  initTrackOrder();
  setTimeout(initTrackOrder, 500);
  setTimeout(initTrackOrder, 1500);
})();
